import { styled } from 'styled-components';

export const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  gap: 0.5rem;
  height: 100%;
  padding: 0 0.5rem 0.5rem;

  @media print {
    padding: 0;
    position: fixed;
    width: calc(100% - 2.5rem);
  }
`;

export const WeekColumn = styled.div`
  height: calc(100svh - var(--banner-height) - 2px - 19.75rem);
`;
